import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import history from 'redux/history';

import StoresReducer from 'redux/Reducers/Stores/StoresReducer';
import AverageReducer from 'redux/Reducers/Average/AverageReducer';
import ToDoReducer from 'redux/Reducers/ToDo/ReducerToDo';
import ReducerOidc from 'redux/Reducers/Oidc/ReducerOidc';
import CatalogReducer from 'redux/Reducers/Catalog/CatalogReducer';
import ExtractReducer from 'redux/Reducers/Extract';
import BalanceReducer from 'redux/Reducers/Balance/BalanceReducer';
import CardBrandsReducer from 'redux/Reducers/CardBrands/CardBrandsReducer';
import RegulationReducer from 'redux/Reducers/Regulation/RegulationReducer';
import ShippingReducer from 'redux/Reducers/Shipping/ShippingReducer';
import ParticipantsReducer from 'redux/Reducers/Participants/ParticipantsReducer';
import CmsStaticReducer from 'redux/Reducers/CmsStatic/CmsStaticReducer';
import ShowcasesReducer from 'redux/Reducers/Showcases/ShowcasesReducer';
import AvailabilityReducer from 'redux/Reducers/Availability/AvailabilityReducer';
import VendorsReducer from 'redux/Reducers/Vendors/VendorsReducer';
import AutocompleteReducer from 'redux/Reducers/Autocomplete';
import CartReducer from 'redux/Reducers/Cart/CartReducer';
import BannersReducer from 'redux/Reducers/Banner/BannersReducer';
import {
  ProductsReducer,
  ProductsGenericReducer,
  ProductsRelatedReducer,
} from 'redux/Reducers/Products/ProductsReducer';
import PointsPlusCashReducer from 'redux/Reducers/PointsPlusCash/PointsPlusCashReducer';
import RatingStoreReducer from 'redux/Reducers/RatingStore/RatingStoreReducer';
import RatingProductReducer from 'redux/Reducers/RatingProduct/RatingProductReducer';
import SearchReducer from 'redux/Reducers/Search/SearchReducer';
import ReportRedemptionSlice from './Reducers/ReportRedemption/ReportRedemptionSlice';
import PaymentConfigReducer, {
  AuthorizationBraspagReducer,
  CreatePurchaseReducer,
  PaymentInstallmentsReducer,
} from './Reducers/Checkout/CheckoutReducer';
import TagReducer from './Reducers/Tag/TagReducer';
import ShowcaseListSlice from './Reducers/Showcases/ShowcaseListReducer';
import ShowcaseMenuSlice from './Reducers/Showcases/ShowcaseMenuReducer';
import AutomateShowcaseSlice from './Reducers/Showcases/ShowcaseAutomateReducer';
import SpotNewSolicitationSlice from './Reducers/Spot/spotNewSolicitationSlice';
import SpotGroupsSlice from './Reducers/Spot/spotGroupsSlice';
import OrderListReducer from './Reducers/Orders/OrdersList';
import OrderDetailsReducer from './Reducers/Orders/OrderDetails';
import TrackingReducer from './Reducers/Tracking/TrackingReducer';
import TrackingPGSReducer from './Reducers/Tracking/TrackingPGSReducer';
import GiftSlice from './Reducers/Gift/GiftSlice';
import VertemGiftSlice from './Reducers/PopBallon/VertemGiftSlice';
import ParticipantGroupSlice from './Reducers/ParticipantGroup/ParticipantGroupSlice';
import AddressSlice from './Reducers/Address/AddressSlice';
import ValidateIeSlice from './Reducers/StateInscription/StateInscriptionReducer';
import SpotListSolicitation from './Reducers/Spot/spotListSolicitation';
import SpotAproveRedemptionSlice from './Reducers/Spot/spotAproveRedemption';
import ShippingSlice from './Reducers/Shipping/ShippingSlice';
import DifalSlice from './Reducers/Difal/DifalSlice';
import ViewRedemptionReducer from './Reducers/ViewRedemption/ViewRedemptionSlice';
import {
  AreaCodesReducer,
  MobileOperatorReducer,
  RechargeValuesReducer,
} from './Reducers/MobileOperator/MobileOperatorReducer';
import { QuotationReducer } from './Reducers/Quotation/QuotationReducer';
import FuelCreditReducer from './Reducers/FuelCredit/FuelCreditReducer';
import ApproveHierarchySlice from './Reducers/Spot/spotAproveHierarchy';
import BillPaymentServicesReducer from 'redux/Reducers/BillPaymentServices/BillPaymentServicesReducer';
import ApproveQuotationSlice from './Reducers/Quotation/ApproveQuotation';
import AvailabilityGenericReducer from './Reducers/Availability/AvailabilityGenericReducer';
import templateReducer from './Reducers/Template/TemplateReducer';
import AvailableVendorsReducer from './Reducers/Vendors/AvailableVendorsReducer';
import SpotEditRedemption from './Reducers/Spot/spotEditRedemption';
import CartTableSlice from './Reducers/Cart/CartTableReducer';
import FetchCartUnavailableSlicer from './Reducers/Cart/fetchCartUnavailableSlicer';
import cardBrandSlice from './Reducers/CardBrand/cardBrandSlice';
import RequestTypeSlicer from './Reducers/Concierge/requestTypeSlicer';
import ConciergeLoginSlicer from './Reducers/Concierge/conciergeLoginSlicer';
import ClientHierarchySlicer from './Reducers/Concierge/clientHierarchySlicer';
import RequestCategorySlicer from './Reducers/Concierge/requestCategorySlicer';
import SupplierSlicer from './Reducers/Concierge/supplierSlicer';
import AddressSlicer from './Reducers/Concierge/addressSlicer';
import ApproveQuotationSlicer from './Reducers/Concierge/approveQuotationSlicer';
import ReopenSolicitationSlicer from './Reducers/Concierge/reopenSolicitationSlicer';
import UploadFileSlicer from './Reducers/Concierge/uploadFileSlicer';
import RejectQuotationSlicer from './Reducers/Concierge/rejectQuotationSlicer';
import CancelQuotationSlicer from './Reducers/Concierge/cancelQuotationSlicer';
import GetManageSolicitationSlicer from './Reducers/Concierge/getManageSolicitationSlicer';
import GetPointsSlicer from './Reducers/Concierge/getPointsSlicer';
import RequestSolicitationEditSlicer from './Reducers/Concierge/requestSolicitationEditSlicer';
import SolicitationCreateSlicer from './Reducers/Concierge/solicitationCreateSlicer';
import SolicitationEditSlicer from './Reducers/Concierge/solicitationEditSlicer';
import RequestPaginationSolicitationSlicer from './Reducers/Concierge/requestPaginationSolicitationSlicer';
import GetSubCategoryBillPaymentSlicer from './Reducers/Concierge/getSubCategoryBillPaymentSlicer';
import ValidateBarCodeSlicer from './Reducers/Concierge/validateBarCodeSlicer';
import GetConvertedPriceSlice from './Reducers/Concierge/getConvertedPriceSlice';
import GetConvertedPointsSlice from './Reducers/Concierge/getConvertedPointsSlice';
import validateGroupSlice from './Reducers/Concierge/validateGroupSlice';
import approveQuotationWithTermSlice from "./Reducers/Concierge/approveQuotationWithTerm";
import approveProposedQuotationSlice from "./Reducers/Concierge/approveProposedQuotation";
import createSupplierSlice from './Reducers/Concierge/createSupplierSlice';
import RequestSubcategoryFormSlicer from './Reducers/Concierge/requestSubcategoryFormSlicer';
import getParticipantGroupSlice from './Reducers/ParticipantGroup/getParticipantGroupSlice';
import CategoriesChipsReducer from './Reducers/CategoriesChips/CategoriesChipsReducer';
import GetListManagePointsSlicer from './Reducers/FocalPoint/getListManagePointsSlicer';
import GetListHistorySlicer from './Reducers/FocalPoint/getListHistorySlicer';
import GetListDistributionSlicer from './Reducers/FocalPoint/getListDistributionSlicer';
import GetParticipantStatusSlicer from './Reducers/FocalPoint/getParticipantStatusSlicer';
import GetParticipantIsFocalPointSlicer from './Reducers/FocalPoint/getParticipantIsFocalPointSlicer';
import SendEmailSlicer from './Reducers/FocalPoint/sendEmailSlicer';
import GetManagePointsSlicer from './Reducers/FocalPoint/getManagePointsSlicer';
import CreateCreditRequestSlicer from './Reducers/FocalPoint/createCreditRequestSlicer';
import GetParticipantByDocumentSlicer from './Reducers/FocalPoint/getParticipantByDocumentSlicer';
import LoadingSlice from './Reducers/Loading/LoadingSlice';
import WishListSlice from './Reducers/WishList/WishListSlice';

const Reducers = combineReducers({
  oidc: ReducerOidc,
  router: connectRouter(history),
  ToDoState: ToDoReducer,
  Search: SearchReducer,
  Autocomplete: AutocompleteReducer,
  Banners: BannersReducer,
  Cart: CartReducer,
  Catalog: CatalogReducer,
  Extract: ExtractReducer,
  Balance: BalanceReducer,
  CardBrands: CardBrandsReducer,
  Regulation: RegulationReducer,
  Shipping: ShippingReducer,
  Participants: ParticipantsReducer,
  CmsStatic: CmsStaticReducer,
  Showcase: ShowcasesReducer,
  Availability: AvailabilityReducer,
  AvailabilityGeneric: AvailabilityGenericReducer,
  Tag: TagReducer,
  ViewRedemption: ViewRedemptionReducer,
  WishList: WishListSlice,
  Vendors: VendorsReducer,
  CategoriesChips: CategoriesChipsReducer,
  PaymentConfig: PaymentConfigReducer,
  PaymentInstallments: PaymentInstallmentsReducer,
  CreatePurchase: CreatePurchaseReducer,
  AuthorizationBraspag: AuthorizationBraspagReducer,
  Stores: StoresReducer,
  Average: AverageReducer,
  ReportRedemption: ReportRedemptionSlice,
  ShowcaseList: ShowcaseListSlice,
  ShowcaseMenu: ShowcaseMenuSlice,
  ValidateIe: ValidateIeSlice,
  AutomateShowcase: AutomateShowcaseSlice,
  SpotNewSolicitation: SpotNewSolicitationSlice,
  SpotGroups: SpotGroupsSlice,
  SpotEditRedemption: SpotEditRedemption,
  OrdersList: OrderListReducer,
  Products: ProductsReducer,
  ProductsGeneric: ProductsGenericReducer,
  ProductsRelated: ProductsRelatedReducer,
  PointsPlusCash: PointsPlusCashReducer,
  OrderDetails: OrderDetailsReducer,
  Tracking: TrackingReducer,
  TrackingPGS: TrackingPGSReducer,
  Gift: GiftSlice,
  VertemGift: VertemGiftSlice,
  ParticipantGroups: ParticipantGroupSlice,
  Address: AddressSlice,
  RatingStore: RatingStoreReducer,
  RatingProduct: RatingProductReducer,
  SpotListSolicitation: SpotListSolicitation,
  SpotAproveRedemption: SpotAproveRedemptionSlice,
  SpotApproveHierarchy: ApproveHierarchySlice,
  ShippingSlice: ShippingSlice,
  DifalSlice: DifalSlice,
  MobileOperator: MobileOperatorReducer,
  AreaCodes: AreaCodesReducer,
  RechargeValues: RechargeValuesReducer,
  Quotation: QuotationReducer,
  FuelCredit: FuelCreditReducer,
  ApproveQuotation: ApproveQuotationSlice,
  BillPaymentServices: BillPaymentServicesReducer,
  Template: templateReducer,
  AvailableVendors: AvailableVendorsReducer,
  CartReducerTable: CartTableSlice,
  CardBrandReducer: cardBrandSlice,
  RequestType: RequestTypeSlicer,
  ClientHierarchy: ClientHierarchySlicer,
  RequestCategory: RequestCategorySlicer,
  Supplier: SupplierSlicer,
  AddressSlicer: AddressSlicer,
  RequestSolicitationEdit: RequestSolicitationEditSlicer,
  SolicitationCreate: SolicitationCreateSlicer,
  SolicitationEdit: SolicitationEditSlicer,
  RequestPaginationSolicitation: RequestPaginationSolicitationSlicer,
  ApproveQuotationSolicitation: ApproveQuotationSlicer,
  CancelQuotationSolicitation: CancelQuotationSlicer,
  GetManageSolicitation: GetManageSolicitationSlicer,  
  RejectQuotation: RejectQuotationSlicer,
  GetPoints: GetPointsSlicer,
  ReopenSolicitation: ReopenSolicitationSlicer,
  UploadFile: UploadFileSlicer,
  ConciergeLogin: ConciergeLoginSlicer,
  GetSubCategoryBillPayment: GetSubCategoryBillPaymentSlicer,
  ValidateBarCode: ValidateBarCodeSlicer,
  GetConvertedPrice: GetConvertedPriceSlice,
  GetConvertedPoints: GetConvertedPointsSlice,
  ValidateGroup: validateGroupSlice,
  ApproveQuotationWithTerm: approveQuotationWithTermSlice,
  ApproveProposedQuotation: approveProposedQuotationSlice,
  CreateSupplier: createSupplierSlice,
  RequestSubcategoryForm: RequestSubcategoryFormSlicer,
  GetParticipantGroup: getParticipantGroupSlice,
  GetListManagePoints: GetListManagePointsSlicer,
  GetListHistory: GetListHistorySlicer,
  GetListDistribution: GetListDistributionSlicer,
  GetParticipantStatus: GetParticipantStatusSlicer,
  GetParticipantIsFocalPoint: GetParticipantIsFocalPointSlicer,
  SendEmail: SendEmailSlicer,
  GetManagePoints: GetManagePointsSlicer,
  CreateCreditRequest: CreateCreditRequestSlicer,
  GetParticipantByDocument: GetParticipantByDocumentSlicer,
  Loading: LoadingSlice,
  FetchCartUnavailable: FetchCartUnavailableSlicer,
});

export default Reducers;
